import EvidenceLinkBrowser from './EvidenceLinkBrowser'

/** Investigation case modal — thin wrapper around shared EvidenceLinkBrowser. */
export default function LinkTransactionModal({
  caseId,
  isOpen,
  onClose,
  onAdded,
  defaultMemberId = '',
  defaultMemberName = '',
  defaultEgmHouseNo = '',
  defaultLane = 'combined',
  defaultCombinedView = 'session',
  defaultTradingDay = '',
  defaultDateFrom = '',
  defaultDateTo = '',
  stepId = null,
  title = 'Add patron activity',
}) {
  if (!caseId) return null

  return (
    <EvidenceLinkBrowser
      display="modal"
      isOpen={isOpen}
      onClose={onClose}
      onLinked={onAdded}
      context={{ type: 'investigation_case', id: caseId }}
      defaultMemberNumber={defaultMemberId}
      defaultMemberName={defaultMemberName}
      defaultEgmHouseNo={defaultEgmHouseNo}
      defaultLane={defaultLane}
      defaultCombinedView={defaultCombinedView}
      defaultTradingDay={defaultTradingDay}
      defaultDateFrom={defaultDateFrom}
      defaultDateTo={defaultDateTo}
      stepId={stepId}
      title={title}
      showCsvTab
    />
  )
}
